import { render, staticRenderFns } from "./SupplierStatis.vue?vue&type=template&id=180926de&scoped=true"
import script from "./SupplierStatis.vue?vue&type=script&lang=js"
export * from "./SupplierStatis.vue?vue&type=script&lang=js"
import style0 from "./SupplierStatis.vue?vue&type=style&index=0&id=180926de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180926de",
  null
  
)

export default component.exports